import { getVerticalScrollContainer, scrollAnchorToViewportTop, scrollWindowToYInstant } from './scrollUtil';

const TYPE_AOS_LAYOUT_PROPS = ['height', 'minHeight', 'overflow', 'paddingTop'];

function rememberInlineStyle(el) {
  if (!el || el.dataset.typeAosSchedLayout) return;
  el.dataset.typeAosSchedLayout = '1';
  TYPE_AOS_LAYOUT_PROPS.forEach((prop) => {
    el.dataset[`typeAosSchedOrig_${prop}`] = el.style[prop] || '';
  });
}

function setInlineStyles(el, styles) {
  if (!el) return;
  rememberInlineStyle(el);
  Object.assign(el.style, styles);
}

/**
 * Android type-aos: 퍼블 CSS 가 html/contents/schedule_table_w 에 고정 높이를 주면
 * document 스크롤·sticky 가 깨짐. CSS 파일 수정 전 JS 보정(페이지 이탈 시 복원).
 */
export function ensureTypeAosScheduleDocumentScrollLayout() {
  if (typeof window === 'undefined') return false;
  if (!document.querySelector('.timetable_wrap.app2026.type-aos')) return false;

  setInlineStyles(document.documentElement, {
    height: 'auto',
    minHeight: '100%',
  });
  const contents = document.getElementById('container');
  setInlineStyles(contents, {
    height: 'auto',
    overflow: 'visible',
    paddingTop: '0',
  });
  const scheduleTable = document.querySelector(
    '.timetable_wrap.app2026.type-aos .schedule_table_w'
  );
  setInlineStyles(scheduleTable, {
    height: 'auto',
    minHeight: '0',
    overflow: 'visible',
  });
  return true;
}

export function restoreTypeAosScheduleDocumentScrollLayout() {
  if (typeof window === 'undefined') return;
  const restoreEl = (el) => {
    if (!el?.dataset?.typeAosSchedLayout) return;
    TYPE_AOS_LAYOUT_PROPS.forEach((prop) => {
      const key = `typeAosSchedOrig_${prop}`;
      el.style[prop] = el.dataset[key] || '';
      delete el.dataset[key];
    });
    delete el.dataset.typeAosSchedLayout;
  };
  restoreEl(document.documentElement);
  restoreEl(document.getElementById('container'));
  restoreEl(
    document.querySelector('.timetable_wrap.app2026.type-aos .schedule_table_w')
  );
}

/**
 * 전체편성표 전용: 날짜 탭 가로 스크롤.
 * 퍼블: overflow-x 는 ul.list01 이 아니라 부모 .tab-type001 에 있음.
 */
export function scrollDateTabIntoView(listEl, dateStr) {
  if (typeof window === 'undefined' || !listEl || !dateStr) return false;
  const scrollEl = listEl.closest('.tab-type001');
  if (!scrollEl) return false;
  const item = listEl.querySelector(`li[data-date="${dateStr}"]`);
  if (!item) return false;

  const containerWidth = scrollEl.clientWidth;
  const scrollWidth = scrollEl.scrollWidth;
  const itemWidth = item.offsetWidth;
  if (!containerWidth || !itemWidth) return false;

  const containerRect = scrollEl.getBoundingClientRect();
  const itemRect = item.getBoundingClientRect();
  const itemLeftInContainer =
    itemRect.left - containerRect.left + scrollEl.scrollLeft;

  let scrollLeft = itemLeftInContainer - (containerWidth - itemWidth) / 2;
  scrollLeft = Math.max(0, Math.min(scrollLeft, scrollWidth - containerWidth));
  scrollEl.scrollLeft = scrollLeft;
  return true;
}

/** 전체편성표 전용: LIVE/첫 편성 행을 `.timetableTab_w` 아래 `.schedule_table_w` 상단으로 
 *  인라인으로 조정하기로 퍼블과 협의되었음 260616 
*/
export function scrollScheduleRowBelowTimetableTabs(rowEl) {
  if (typeof window === 'undefined' || !rowEl) return;
  const isTypeAos = Boolean(
    document.querySelector('.timetable_wrap.app2026.type-aos')
  );
  const scheduleWrap =
    document.querySelector('.timetable_wrap.app2026 .schedule_table_w.active') ||
    document.querySelector('.timetable_wrap.app2026 .schedule_table_w');
  const listPadTop = scheduleWrap
    ? parseFloat(window.getComputedStyle(scheduleWrap).paddingTop) || 0
    : 0;

  if (isTypeAos) {
    ensureTypeAosScheduleDocumentScrollLayout();
    const tabEl = document.querySelector(
      '.timetable_wrap.app2026.type-aos .timetableTab_w'
    );
    const tabH = tabEl ? tabEl.getBoundingClientRect().height : 0;
    const rowDocTop =
      rowEl.getBoundingClientRect().top +
      (window.pageYOffset || document.documentElement.scrollTop || 0);
    const nextY = Math.max(0, rowDocTop - tabH - listPadTop);
    const curY = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (Math.abs(curY - nextY) < 1) return;
    scrollWindowToYInstant(nextY);
    return;
  }

  const tab = document.querySelector('.timetableTab_w');
  const desiredTop = scheduleWrap
    ? scheduleWrap.getBoundingClientRect().top + listPadTop
    : (tab ? tab.getBoundingClientRect().bottom : 0) + listPadTop;
  const scrollRoot =
    getVerticalScrollContainer(scheduleWrap) || scheduleWrap;
  scrollAnchorToViewportTop(rowEl, desiredTop, scrollRoot);
}
